import styles from './scss/abstracts/_variables.scss'
import layers from './scss/abstracts/_layers.scss'

const BoltTheme = {
  ...styles,
  ...layers
}

export default BoltTheme
